import { Button } from './button';

interface CopyTextButtonProps {
  text: string;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  margin?: number;
}

export const CopyTextButton = (props: CopyTextButtonProps) => {
  const { text, disabled = false, className, margin = 10, children } = props;

  // テキストをコピーする
  const copyText = () => {
    navigator.clipboard.writeText(text);
    window.alert('クリップボードにコピーしました');
  };

  return (
    <Button
      className={className}
      disabled={disabled}
      onClick={copyText}
      margin={margin}
    >
      {children}
    </Button>
  );
};
